import { down } from 'styled-breakpoints';
import styled from 'styled-components';

export const HeaderWrapper = styled.header`
    background-color: ${({ theme }) => theme.palette.common.white};

    margin: 20px 32px 32px;
    border-radius: 50px;

    min-height: 120px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    column-gap: 30px;

    .logo_wrapper {
        display: flex;
        align-items: center;
        width: 33.3%;
        padding: ${({ theme }) => theme.spacers.medium};
        div,
        svg {
            width: 350px;
            height: auto;
        }
    }

    ${down('xl')} {
        column-gap: 0;
        align-items: flex-start;
        flex-direction: column;
        .logo_wrapper {
            width: 100%;
            padding: 20px ${({ theme }) => theme.spacers.medium};
        }
    }

    ${down('sm')} {
        margin: 16px 16px ${({ theme }) => theme.spacers.small};
        .logo_wrapper {
            padding: 20px;
            display: block;
            max-width: 350px;

            div,
            svg {
                width: 100%;
            }
        }
    }
    @media screen and (max-width: 400px) {
        margin: 16px 0;
    }
`;

export const TitleWrapper = styled.div`
    flex: 1;
    width: 65%;
    padding: 35px 60px;
    ${down('xl')} {
        width: 100%;
        padding: 20px ${({ theme }) => theme.spacers.medium};
    }
    ${down('sm')} {
        padding: 20px;
        padding-top: 0;
    }
`;

export const PreTitle = styled.small`
    font-style: normal;
    font-weight: 400;
    font-size: 18px;

    /* identical to box height */

    letter-spacing: 0.03em;
    text-transform: uppercase;

    color: rgba(0, 0, 0, 0.5);

    span {
        margin-left: 10px;
        border: 1px solid #808080;
        border-radius: 40px;
        padding: 3px 10px;
    }

    ${down('sm')} {
        font-size: 14px;
        line-height: 16px;
    }
`;

export const Title = styled.h2`
    font-weight: 700;
    font-size: 21px;
    line-height: 130%;

    text-transform: uppercase;

    margin-top: 10px;
    margin-bottom: 0.5rem;

    ${down('xl')} {
        max-width: 705px;
    }
    ${down('sm')} {
        max-width: 397px;
        font-size: 18px !important;
        line-height: 130% !important;
        max-width: 360px;
    }
`;
